import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Table, Icon, Header } from 'semantic-ui-react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { QcReportMetadata } from '../../app/models/Restoration';
import { useStore } from '../../app/stores/store';
import UnauthorizedMessage from '../UnauthorizedMessage';

const QcTable = () => {
  const { RestorationStore, commonStore } = useStore();
  const { QcData, qcData } = RestorationStore;
  const [groupedData, setGroupedData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [restorationinfo, setRestorationinfo] = useState<
    any[] | QcReportMetadata
  >([]);

  useEffect(() => {
    QcData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setRestorationinfo(qcData);
  }, [restorationinfo, qcData, groupedData]);
  React.useEffect(() => {
    const groupedData = {} as any;
    Object.values(restorationinfo)?.forEach((item: QcReportMetadata) => {
      if (!groupedData[item.title_Code]) {
        groupedData[item.title_Code] = [];
      }
      groupedData[item.title_Code].push(item);
    });

    setGroupedData(Object.values(groupedData));
  }, [restorationinfo]);

  const toggleExpandRow = (titleCode: any) => {
    setExpandedRow(expandedRow === titleCode ? null : titleCode);
  };
  if (!commonStore.filterModeOne?.includes('RSQCT01'))
    return (
      <div>
        {' '}
        <UnauthorizedMessage />{' '}
      </div>
    );
  return (
    <>
      {RestorationStore.loading ? (
        <div style={{ margin: '10px' }}>
          <LoadingComponent />
        </div>
      ) : (
        <div className="title-wise-table">
          <Header>Quality Reject Summary</Header>
          <div className="tr-dropdown">
            <Table>
              <Table.Header>
                <Table.Row textAlign="center">
                  <Table.HeaderCell rowSpan={2}>Title Code</Table.HeaderCell>
                  <Table.HeaderCell colSpan={5}>
                    Reel and Shot Info
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan={5}>
                    Quality Check Info
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>Reel Name</Table.HeaderCell>
                  <Table.HeaderCell>Shot Name</Table.HeaderCell>
                  <Table.HeaderCell>Start Frame</Table.HeaderCell>
                  <Table.HeaderCell>End Frame</Table.HeaderCell>
                  <Table.HeaderCell>Total Frame</Table.HeaderCell>
                  <Table.HeaderCell>NoofQCCycle</Table.HeaderCell>
                  <Table.HeaderCell>NoofQcRejectFrame</Table.HeaderCell>
                  <Table.HeaderCell>NoofFQACycle</Table.HeaderCell>
                  <Table.HeaderCell>NoofFQARejectFrame</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {groupedData.map((group: any, index: number) => (
                  <React.Fragment key={index}>
                    <Table.Row
                      onClick={() => toggleExpandRow(group[0]?.title_Code)}
                    >
                      <Table.Cell>{group[0]?.title_Code}</Table.Cell>
                      <Table.Cell colSpan={10}>
                        {expandedRow === group[0]?.title_Code ? (
                          <Icon name="minus" color="grey" />
                        ) : (
                          <Icon name="plus" color="grey" />
                        )}
                      </Table.Cell>
                    </Table.Row>
                    {expandedRow === group[0]?.title_Code &&
                      group?.map((item: any, index: number) => (
                        <Table.Row key={index}>
                          <Table.Cell />
                          <Table.Cell>{item.reel_Name}</Table.Cell>
                          <Table.Cell>{item.shot_Name}</Table.Cell>
                          <Table.Cell>{item.start_Frame}</Table.Cell>
                          <Table.Cell>{item.end_Frame}</Table.Cell>
                          <Table.Cell>{item.total_Frame}</Table.Cell>
                          <Table.Cell>{item.noofQCCycle}</Table.Cell>
                          <Table.Cell>{item.noofQcRejectFrame}</Table.Cell>
                          <Table.Cell>{item.noofFQACycle}</Table.Cell>
                          <Table.Cell>{item.noofFQARejectFrame}</Table.Cell>
                        </Table.Row>
                      ))}
                  </React.Fragment>
                ))}
              </Table.Body>
            </Table>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(QcTable);
